<template lang="pug">
    div
        // Deactivate account section
        div.setting
            div.deactivate
                div

                    // Deactivate account title
                    title-component.deactivateTitle(type="h5" :title="$t('business.edit.settings.deactivate.title')")

                div.ml-3

                    // Switch (tooggle activate/deactivate account)
                    v-switch.c-switch(
                        :label="isDeactivated ? 'Yes' : 'No'"
                        v-model="isDeactivated"
                        :disabled="isLoading"
                        @change="toggleActivation"
                        color="action"
                        hide-details
                    )

            // Deactivate account description
            div.description {{ $t('business.edit.settings.deactivate.description') }}

        // Horizontal line
        separator-component

        // Delete account section
        div.setting

            // Delete account title
            title-component(type="h5" :title="$t('business.edit.settings.delete.title')")

            // Delete account description
            div.description.pb-2 {{ $t('business.edit.settings.delete.description') }}

            // Delete account button
            button-component.ml-0(
                :action="() => deleteAccount(model.id)"
                :loading="isLoading"
                :disabled="isLoading"
                color="error"
                outline
            ) {{ $t('business.edit.settings.delete.button') }}

        // Horizontal line
        separator-component

        // Reset account password section
        div

            // Reset account title
            title-component(type="h5" :title="$t('business.edit.settings.reset.title')")

            // Reset account description
            div.description.pb-2 {{ $t('business.edit.settings.reset.description') }}

            // Reset password button
            button-component.ml-0(
                :action="resetPassword"
                :loading="isLoading"
                :disabled="isLoading"
                color="white"
                outline
            ) {{ $t('business.edit.settings.reset.button') }}
</template>

<script>
    import Button from '~components/Button';
    import Separator from '~components/Separator';
    import Title from '~components/Title';
    import { mapActions, mapGetters } from 'vuex';
    import { mapFields } from 'vuex-map-fields';

    export default {
        components: {
            TitleComponent: Title,
            ButtonComponent: Button,
            SeparatorComponent: Separator
        },
        computed: {
            ...mapFields('businesses', {
                model: 'business'
            }),
            ...mapGetters('businesses', ['isLoading']),
            isDeactivated: {
                get: function() {
                    return !this.model.isActive;
                },
                set: function(newValue) {
                    this.model.isActive = !newValue;
                }
            }
        },
        methods: {
            ...mapActions('businesses', [
                'resetPassword',
                'deleteAccount',
                'updateStatus'
            ]),

            /**
             * Activate/Deactivate account
             */
            toggleActivation() {
                this.$store.dispatch('businesses/updateStatus');
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'

    .deactivate
        display: flex

    .deactivateTitle
        margin-top: 2px
</style>
